export default "__VITE_ASSET__8Y6x9Zrk__"